import Grid from '@mui/material/Grid'
import Grow from '@mui/material/Grow'
import { useSelector } from 'react-redux'
import { classes, UnitListStyle } from './style'
import UnitEmpty from './unitEmpty'
import Unit from './unit'

const UnitList = () => {
  const unitStore = useSelector(state => state.viewer.units)
  return (
    <Grid container spacing={2}>
      {unitStore.map((unit, i) => {
        const checked = i + 1
        return (
          <Grid item xs={12} key={i}>
            <Grow in={!!checked}{...(checked ? { timeout: 1000 } : {})}>
              <UnitListStyle className={classes.root}>
                {!unit.available && <UnitEmpty unit={unit}/> }
                {unit.available && <Unit unit={unit}/> }
              </UnitListStyle>
            </Grow>
          </Grid>
        )
      })}
    </Grid>

  )
}

export default UnitList
